<template>
  <form class="booking-cancel" @submit.prevent="cancel">
    <div class="modal-content-generic">
      <div class="content lh-loose">
        <div v-if="cancellation_policy">
          <h3 class="mb-2">You have requested to Cancel your booking</h3>
          <div class="alert alert-error no-top-margin">
            <div v-html="cancellation_policy" class="formatted"></div>
          </div>
        </div>
        <div class="form-group vanilla" :class="{'has-input-error': errors.reason}">
          <label>Please confirm your reason for cancelling this {{ data.booking_type_label }}</label>
          <textarea class="slim" v-model="reason"></textarea>
        </div>
        <div class="form-group vanilla checkbox-container no-divider"
             :class="{'has-input-error': errors.agree_terms}">
          <checkbox v-model="agree_terms" :required="true">
            <template v-slot:checkbox-label>
              I agree to the cancellation policy as per above
              <span class="required">*</span>
            </template>
          </checkbox>
        </div>
      </div>
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button tertiary" @click="keep">
          <svg-icon id="chevronLeft"></svg-icon>
          <span>Keep {{ data.booking_type_label }}</span>
        </button>
      </div>
      <div class="action">
        <loader-button
            type="submit"
            :loading="loading"
            :label="`Cancel ${data.type}`"
            class="button danger"
        ></loader-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  mounted () {
    this.loading = true
    axios.get('/api/form-meta/cancellation-policy')
        .then(response => {
          this.cancellation_policy = response.data
        })
        .then(() => {
          this.loading = false
        })
  },
  data () {
    return {
      reason: null,
      agree_terms: false,
      cancellation_policy: null,
      errors: {},
      loading: false
    }
  },
  methods: {
    cancel () {
      this.errors = {}
      this.loading = true
      axios.put(`/api/account/bookings/${this.data.id}/cancel`, {
        reason: this.reason,
        agree_terms: this.agree_terms
      })
          .then(() => {
            this.$toasted.show(`Your ${this.data.booking_type_label} has been cancelled.`, { type: 'success' })
            this.reason = null
            this.$emit('confirm')
            this.$eventBus.$emit('update_listing_booking-item')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.$toasted
                  .show(`Please confirm your reason for cancelling this ${this.data.booking_type_label}.`, {
                    type: 'error'
                  })
              return this.errors = error.response.data.errors
            }
            this.$toasted.show(
                `Your ${this.data.booking_type_label} could not be cancelled, please refresh the page and try again.`, {
                  type: 'error'
                })
          })
          .then(() => {
            this.loading = false
          })
    },
    keep () {
      this.$emit('cancel')
    }
  }
}
</script>
